import { config } from 'src/config';
import { requestWithRetry } from 'src/shared/utils/request';

enum ViewerVersion {
  DESIGN_STUDIO = 'design_studio',
  RENDERINGS_HUB = 'renderings_hub',
  PAINT_MEASUREMENTS = 'paint_measurements',
}

type JobShareData = {
  expired: boolean;
  id: number;
  image_url: string | null;
  job_id: number;
  token: string;
  url: string;
  user_id: number;
};

type JobShareJSONResponse = {
  job_share?: JobShareData;
};

const createJobShare = async (
  jobId: number,
  viewerVersion: ViewerVersion,
  imageBlob?: Blob,
) => {
  const endpoint = `${config.API_URI}/job_shares`;
  const formData = new FormData();

  formData.append('job_share[job_id]', jobId.toString());
  formData.append('job_share[viewer_version]', viewerVersion);
  if (imageBlob) {
    formData.append('job_share[image]', imageBlob);
  }

  const credentials: RequestCredentials = 'include';

  const headers = new Headers();
  headers.append('Access-Control-Allow-Credentials', 'true');

  const requestOptions = {
    method: 'POST',
    body: formData,
    credentials,
    headers,
  };

  const resp = await requestWithRetry(endpoint, requestOptions);
  const { job_share: jobShare } = await resp.json<JobShareJSONResponse>();
  return jobShare;
};

export { createJobShare, ViewerVersion };
